import React from "react";
import * as chrono from "chrono-node";
import { instantSave } from "../../helpers.js";

const mmDdYyyyFormat = (dateObject) =>
  dateObject.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

const testIsOnlyYear = (val) => !!val.match(/^\d{4}$/);
const testIsOnlyMonthAndYearNatural = (val) => !!val.match(/^\d{4}$/);
const testIsOnlyMonthAndYearNumeric = (val) => !!val.match(/^\d{4}$/);

export default class DateRange extends React.Component {
  state = {
    fromDate: this.props.fromVal,
    fromHidden: this.props.fromVal,
    toDate: this.props.toVal,
    toHidden: this.props.toVal,
  };

  handleInputChange = (event) => {
    const { fromFieldName } = this.props;
    window.unsavedChanges(true);
    const isFrom = event.target.id.includes(fromFieldName);
    const fieldName = isFrom ? "fromDate" : "toDate";
    const newState = {};
    newState[fieldName] = event.target.value;
    this.setState(newState);
  };

  handleDateBlur = (e) => {
    const { fromFieldName } = this.props;
    const { fromHidden, toHidden } = this.state;
    const val = e.target.value;
    const parsed = chrono.parse(val);
    const { start, end } = parsed[0] || {};
    const parsedDates = [start?.date(), end?.date()].filter(Boolean);
    let dates = [fromHidden, toHidden];
    const isFrom = e.target.id.includes(fromFieldName);
    const thisDateIndex = isFrom ? 0 : 1;
    const otherDateIndex = isFrom ? 1 : 0;
    // test if the user input is missing the day or month
    const isOnlyYear = testIsOnlyYear(val);
    const isOnlyMonthAndYearNatural = testIsOnlyMonthAndYearNatural(val);
    const isOnlyMonthAndYearNumeric = testIsOnlyMonthAndYearNumeric(val);
    const otherFieldIsNonstandardFormat =
      testIsOnlyYear(dates[otherDateIndex]) ||
      testIsOnlyMonthAndYearNatural(dates[otherDateIndex]) ||
      testIsOnlyMonthAndYearNumeric(dates[otherDateIndex]);

    // if chrono parses two dates, we will assume that we want to specify the day
    // use the mm/dd/yyyy format
    if (parsedDates.length === 2) {
      dates = parsedDates.map((dateObject) => mmDdYyyyFormat(dateObject));
    } else if (parsedDates.length < 2) {
      // if there is just one date that is parsed, we might want to keep
      // the mm/yyyy or just yyyy format

      // allows user to just enter YYYY without specifying month or day
      if (isOnlyYear) {
        dates[thisDateIndex] = val;
      } else if (isOnlyMonthAndYearNatural) {
        dates[thisDateIndex] = parsedDates[0].toLocaleDateString("en-US", {
          month: "2-digit",
          year: "numeric",
        });
      } else if (isOnlyMonthAndYearNumeric) {
        dates[thisDateIndex] = val;
      } else if (val.length) {
        if (parsedDates[0]) {
          dates[thisDateIndex] = mmDdYyyyFormat(parsedDates[0]);
        } else {
          dates[thisDateIndex] = "";
          alert(`I can't parse a date from what you entered:\n ${val}`);
        }
      } else if (this.state.fromHidden.length) {
        dates[thisDateIndex] = "";
      }
    }

    // Ensure that the "to" field is later than the "from" field
    // Only validate this for mm/dd/yyyy formats
    if (
      dates[0] &&
      dates[1] &&
      !(isOnlyYear || isOnlyMonthAndYearNatural || isOnlyMonthAndYearNumeric) &&
      !otherFieldIsNonstandardFormat
    ) {
      const fromInteger = Number(new Date(chrono.parseDate(dates[0]) * 1000));
      const toInteger = Number(new Date(chrono.parseDate(dates[1]) * 1000));

      if (fromInteger > toInteger) {
        // reset the appropriate fields if input was invalid
        if (parsedDates.length === 2) {
          dates = [fromHidden, toHidden];
        } else {
          dates[thisDateIndex] = isFrom ? fromHidden : toHidden;
        }

        alert("The end date must be later than the start date.");
      }
    }

    if (dates[0] !== fromHidden || dates[1] !== toHidden) {
      clearTimeout(window.editableChangeThrottle);
      window.editableChangeThrottle = setTimeout(() => {
        instantSave();
      }, 100);
    } else {
      window.unsavedChanges(false);
    }

    this.setState({
      fromDate: dates[0],
      fromHidden: dates[0],
      toDate: dates[1],
      toHidden: dates[1],
    });
  };

  handleClick = () => {
    const date = prompt("Paste a date or date range here");
    const parsed = chrono.parse(date);
    const text = parsed
      ? [parsed[0].start.date(), parsed[0].end?.date()].join(" ")
      : "";
    alert(text);
  };

  render() {
    const { recordType, fromFieldName, fromLabel, toFieldName, toLabel } =
      this.props;
    const { fromDate, fromHidden, toDate, toHidden } = this.state;
    const placeholder = `e.g. "Apr 3-24, 2020", "June 1994", or "1993"`;

    return (
      <>
        <div className="record-field record-field-date">
          <label htmlFor={`#${fromFieldName}-input`}>{fromLabel}</label>

          <input
            id={`${fromFieldName}-input`}
            type="text"
            spellCheck="false"
            value={fromDate}
            onChange={this.handleInputChange}
            onBlur={this.handleDateBlur}
            placeholder={placeholder}
          />

          <input
            type="hidden"
            name={`${recordType}[${fromFieldName}]`}
            value={fromHidden}
          />
        </div>

        <div className="record-field record-field-date">
          <label htmlFor={`#${toFieldName}-input`}>{toLabel}</label>

          <input
            id={`${toFieldName}-input`}
            type="text"
            spellCheck="false"
            value={toDate}
            onChange={this.handleInputChange}
            onBlur={this.handleDateBlur}
            placeholder={placeholder}
          />

          <input
            type="hidden"
            name={`${recordType}[${toFieldName}]`}
            value={toHidden}
          />
        </div>
      </>
    );
  }
}
